<template>
  <svg
    class="custom-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="2" fill="rgb(var(--v-theme-secondary))" />
    <path
      d="M3 7L6.19328 10L11 4"
      stroke="rgb(var(--v-theme-primary))"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
